// src/components/LoginForm.tsx
import React, { useState } from "react"
import styled from "styled-components"
import { LoginResponse } from "../types/auth"

interface LoginFormProps {
  onLogin: (accessToken: string, refreshToken: string) => void
}

const LoginForm: React.FC<LoginFormProps> = ({ onLogin }) => {
  const [username, setUsername] = useState("")
  const [password, setPassword] = useState("")
  const [error, setError] = useState("")

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError("")

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/auth/login`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username, password }),
        }
      )

      const data: LoginResponse = await response.json()
      if (response.ok) {
        onLogin(data.access_token, data.refresh_token)
      } else {
        setError("Invalid credentials")
      }
    } catch (err) {
      setError("Failed to login")
    }
  }

  return (
    <FormWrapper>
      <FormContainer onSubmit={handleSubmit}>
        <Title>Login</Title>
        <Input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <Input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <Button type="submit">Login</Button>
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </FormContainer>
    </FormWrapper>
  )
}

export default LoginForm

// Styled Components
const FormWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #f0f2f5;
`

const FormContainer = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 300px;
  padding: 2rem;
  background-color: #f9f9fc;
  border-radius: 10px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
`

const Title = styled.h2`
  margin-bottom: 1.5rem;
  color: #7363eb;
  font-size: 1.8rem;
`

const Input = styled.input`
  width: 100%;
  padding: 0.8rem;
  margin-bottom: 1rem;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: #7363eb;
    box-shadow: 0 0 5px rgba(115, 99, 235, 0.5);
  }
`

const Button = styled.button`
  width: 100%;
  padding: 0.8rem;
  background-color: #7363eb;
  color: white;
  font-size: 1rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #5a4cce;
  }
`

const ErrorMessage = styled.p`
  color: #ff4d4f;
  margin-top: 0.5rem;
  font-size: 0.9rem;
`
